import { render, staticRenderFns } from "./PurchasingPayment.vue?vue&type=template&id=87ca1a04"
import script from "./PurchasingPayment.vue?vue&type=script&lang=js"
export * from "./PurchasingPayment.vue?vue&type=script&lang=js"
import style0 from "./PurchasingPayment.vue?vue&type=style&index=0&id=87ca1a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports